'use strict';

(function() {
  const ICON_DEFAULT = 'bx-arrow-to-bottom';
  const ICON_LOADING = 'bx-loader-alt';
  // bx-spin は <i> 自体を回転させ枠まで回ってしまうため使用しない。
  // is-loading 付与時に CSS 側で ::before（グリフ）だけを回す
  const LOADING_CLASS = 'is-loading';
  // 8M ≒ 2896×2896 を上限の目安。大規模順位表で scale=2 のまま処理が肥大化するのを抑える
  const MAX_CANVAS_AREA = 8388608;
  // 全体タイムアウト。html2canvas や toBlob が無限 pending になっても確実にユーザーに失敗を伝える
  const CAPTURE_TIMEOUT_MS = 30000;

  // テスト用フック。本番では未使用。システムスペックで html2canvas を差し替えるための差し込み口
  window.JanrecoTestHooks = window.JanrecoTestHooks || {};

  $(document).on('turbolinks:load', function() {
    $(document).on('click', '.js-save-ranking-btn', handleClick);
  });

  $(document).on('turbolinks:before-cache', function() {
    $('.js-ranking-capture-stage, .js-ranking-toast').remove();
    $('.js-save-ranking-btn').each(function() {
      setLoading($(this), false);
    });
    // モーダルが開いたまま遷移した場合に備えて閉じておく
    const $modal = $('.ranking-image-modal-overlay');
    if ($modal.length) {
      $modal.hide().removeClass('starting').find('.ranking-image-modal').removeClass('starting');
      $modal.find('.js-ranking-image-target').attr('src', '');
    }
  });

  async function handleClick() {
    const $btn = $(this);
    if ($btn.prop('disabled')) return;
    setLoading($btn, true);

    let stage = null;
    let timeoutId = null;

    try {
      const html2canvas = window.JanrecoTestHooks.html2canvasOverride ||
        (await import(/* webpackChunkName: "html2canvas" */ 'html2canvas')).default;

      const ctx = resolveTargets($btn);
      if (!ctx.tableEl) throw new Error('table not found');

      stage = buildStage(ctx, $btn);
      document.body.appendChild(stage);

      // html2canvas や toBlob が無限 pending になるケースに備え、処理全体に上限を設ける
      const timeoutPromise = new Promise(function(_, reject) {
        timeoutId = setTimeout(function() { reject(new Error('capture timeout')); }, CAPTURE_TIMEOUT_MS);
      });

      const capturePromise = (async function() {
        await waitForImages(stage);
        pruneFailedImages(stage);
        // Web フォント（Noto Sans JP 等）が未ロードのままキャプチャすると別フォントで焼かれるため待つ
        if (document.fonts && document.fonts.ready) {
          try { await document.fonts.ready; } catch (_) { /* ignore */ }
        }

        const scale = pickScale(stage);
        const canvas = await html2canvas(stage, {
          useCORS: true,
          scale: scale,
          backgroundColor: '#ffffff',
          logging: false
        });

        const filename = buildFilename($btn.data('league-name'), ctx.kindLabel);
        await deliverImage(canvas, filename, $btn);
      })();

      await Promise.race([capturePromise, timeoutPromise]);
    } catch (err) {
      console.error('Save ranking image failed:', err);
      showToast(String($btn.data('msg-failure')));
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
      if (stage && stage.parentNode) stage.remove();
      setLoading($btn, false);
    }
  }

  function resolveTargets($btn) {
    const type = $btn.data('type');
    if (type === 'team') {
      const target = $('.league-ranking-tab.active').data('target');
      const isTeamTab = target === 'team-panel';
      const titleEl = document.getElementById('ranking-title');
      return {
        headerEl: titleEl ? titleEl.closest('.d-flex') : null,
        tableEl: document.getElementById(isTeamTab ? 'team-rank-table' : 'league-rank-table'),
        kindLabel: String(isTeamTab ? $btn.data('label-team') : $btn.data('label-individual'))
      };
    }
    return {
      headerEl: $btn.closest('.d-flex.section-title-bar')[0] || null,
      tableEl: document.getElementById('league-rank-table'),
      kindLabel: String($btn.data('label-solo'))
    };
  }

  function buildStage(ctx, $btn) {
    const stage = document.createElement('div');
    stage.className = 'js-ranking-capture-stage ranking-capture-stage';
    stage.style.cssText = 'position:fixed;left:-99999px;top:0;background:#fff;padding:16px;';
    stage.style.width = Math.max(ctx.tableEl.offsetWidth, 600) + 'px';
    // Bootstrap の --bs-body-font-family を html2canvas が解決できず別フォントで描画されるのを防ぐため、
    // 画面で解決済みの body の font-family をそのまま焼き付ける
    stage.style.fontFamily = getComputedStyle(document.body).fontFamily;
    stage.style.color = getComputedStyle(document.body).color;

    stage.appendChild(buildTopWatermark($btn.data('league-name')));
    if (ctx.headerEl) stage.appendChild(ctx.headerEl.cloneNode(true));
    stage.appendChild(ctx.tableEl.cloneNode(true));
    stage.appendChild(buildBottomLogo($btn.data('logo-src')));

    // クローン後に保存ボタン自身の DOM を削除（ignoreElements ではレイアウトの隙間が残るため）
    stage.querySelectorAll('.js-no-capture').forEach(function(el) { el.remove(); });

    // 「自分」の強調（名前の太字）は閲覧者ごとに違う情報なので共有用画像には残さない
    stage.querySelectorAll('.is-mine-label').forEach(function(el) { el.classList.remove('is-mine-label'); });

    // stage は画面外（left:-99999px）に配置されるため、loading="lazy" のままだと
    // モバイル Chrome では IntersectionObserver が発火せず fetch がトリガーされず
    // waitForImages が永久に pending になる。クローン側は強制 eager に切り替える
    stage.querySelectorAll('img').forEach(function(img) {
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'sync');
    });

    // 画面側の sticky ヘッダーは html2canvas が正しく描けないため、複製側では静的に戻す
    stage.querySelectorAll('thead th').forEach(function(th) {
      th.style.position = 'static';
      th.style.boxShadow = 'none';
    });

    // html2canvas v1.4 が td の box-shadow inset を描画できないため border-left に置換
    convertInsetShadowToBorder(stage);
    return stage;
  }

  function convertInsetShadowToBorder(stage) {
    stage.querySelectorAll('td').forEach(function(td) {
      const bs = td.style.boxShadow;
      if (!bs) return;
      const widthMatch = bs.match(/(?:inset\s+)?(-?\d+px)\s+0(?:px)?\s+0(?:px)?\s+0(?:px)?(?:\s+inset)?/);
      const colorMatch = bs.match(/#[0-9a-f]{3,8}|rgba?\([^)]+\)/i);
      if (widthMatch && colorMatch) {
        td.style.boxShadow = '';
        td.style.borderLeft = widthMatch[1] + ' solid ' + colorMatch[0];
      }
    });
  }

  function buildTopWatermark(leagueName) {
    const $wm = $('<div>', { class: 'ranking-watermark-top' });
    const $name = $('<div>', { class: 'ranking-watermark-top__league-name' }).text(String(leagueName));
    $wm.append($name);

    const infoEl = document.querySelector('#league-show-top .league-info');
    if (infoEl) {
      const $infoWrap = $('<div>', { class: 'ranking-watermark-top__info' });
      $infoWrap.append(infoEl.cloneNode(true));
      $wm.append($infoWrap);
    }
    return $wm[0];
  }

  function buildBottomLogo(logoSrc) {
    const $wrap = $('<div>', { class: 'ranking-watermark-logo' });
    const $img = $('<img>', { src: logoSrc, alt: 'Janreco', crossorigin: 'anonymous' });
    return $wrap.append($img)[0];
  }

  function waitForImages(root) {
    // 想定外のケース（lazy のフェッチ未トリガー、ネットワーク不通、CORS 失敗など）で
    // onload/onerror いずれも来ないと Promise が永久 pending になり保存 UI が固まる。
    // 画像ごとに上限時間を設けて確実に解決させる
    const TIMEOUT_MS = 8000;
    const imgs = Array.from(root.querySelectorAll('img'));
    return Promise.all(imgs.map(function(img) {
      if (img.complete && img.naturalWidth > 0) return Promise.resolve();
      return new Promise(function(res) {
        let done = false;
        const finish = function() {
          if (done) return;
          done = true;
          res();
        };
        img.onload = finish;
        img.onerror = finish;
        setTimeout(finish, TIMEOUT_MS);
      });
    }));
  }

  // 読込失敗（404・タイムアウト）の <img> を非表示化。
  // CORS 汚染（naturalWidth>0 だが描画時に SecurityError）はここでは検出できず、html2canvas が例外を投げる
  function pruneFailedImages(root) {
    root.querySelectorAll('img').forEach(function(img) {
      if (!img.complete || img.naturalWidth === 0) {
        img.style.display = 'none';
      }
    });
  }

  // 描画後ピクセル数 = w*h*scale^2。scale=2 を試算して上限超過なら scale=1 にダウン
  function pickScale(stage) {
    const w = stage.offsetWidth;
    const h = stage.offsetHeight;
    const renderedPixels = w * h * 2 * 2;
    return renderedPixels > MAX_CANVAS_AREA ? 1 : 2;
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  // 制御文字・改行・前後空白/ピリオドを除去、空白は _ に潰す
  function sanitizeForFilename(s) {
    return String(s || '')
      .replace(/[\/\\:*?"<>|\x00-\x1f]/g, '_')
      .replace(/\s+/g, '_')
      .replace(/^[\s.]+|[\s.]+$/g, '');
  }

  function buildFilename(rawName, kindLabel) {
    const safeName = sanitizeForFilename(rawName).slice(0, 80) || 'league';
    const safeKind = sanitizeForFilename(kindLabel).slice(0, 40) || 'ranking';
    const d = new Date();
    const ymd = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    return safeName + '_' + safeKind + '_' + ymd + '.png';
  }

  function isIOSLike() {
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/i.test(ua)) return true;
    // iPadOS 13+ デスクトップモード
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
    return false;
  }

  function deliverImage(canvas, filename, $btn) {
    return new Promise(function(resolve, reject) {
      canvas.toBlob(function(blob) {
        if (!blob) {
          reject(new Error('toBlob failed'));
          return;
        }
        const url = URL.createObjectURL(blob);

        if (isIOSLike()) {
          openRankingImageModal($btn.data('modal-id'), url);
          showToast(String($btn.data('msg-ios-hint')));
        } else {
          const $a = $('<a>', { href: url, download: filename }).appendTo('body');
          // loading.js が document 上の a[href] クリックを検知してページ遷移用スピナーを出すため、
          // ダウンロードのクリックは document まで伝播させない
          $a.on('click', function(e) { e.stopPropagation(); });
          $a[0].click();
          $a.remove();
          setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
        }
        resolve();
      }, 'image/png');
    });
  }

  function setLoading($btn, on) {
    const $i = $btn.find('i');
    if (on) {
      $btn.prop('disabled', true).attr('aria-busy', 'true');
      $i.removeClass(ICON_DEFAULT).addClass(ICON_LOADING).addClass(LOADING_CLASS);
    } else {
      $btn.prop('disabled', false).attr('aria-busy', 'false');
      $i.removeClass(LOADING_CLASS).removeClass(ICON_LOADING).addClass(ICON_DEFAULT);
    }
  }

  // iOS 用のプレビューモーダル。Bootstrap Modal は使わず DESIGN.md のオリジナルパターンに合わせる
  function openRankingImageModal(modalId, imageUrl) {
    const $overlay = $('#' + modalId);
    if (!$overlay.length) return;
    const $panel = $overlay.find('.ranking-image-modal');
    const $img = $overlay.find('.js-ranking-image-target');
    $img.attr('src', imageUrl);

    function closeModal() {
      $overlay.addClass('starting');
      $panel.addClass('starting');
      let finished = false;
      const end = function() {
        if (finished) return;
        finished = true;
        $overlay.off('transitionend', end);
        $overlay.hide();
        URL.revokeObjectURL(imageUrl);
        $img.attr('src', '');
      };
      $overlay.on('transitionend', end);
      // transitionend が来ない環境向けフォールバック
      setTimeout(end, 420);
      $overlay.off('.rim');
      $(document).off('keydown.rim');
    }

    // 再オープン時の二重バインドを防ぐ
    $overlay.off('.rim');
    $(document).off('keydown.rim');

    $overlay.on('click.rim', '.js-ranking-image-modal-close', function() { closeModal(); });
    $overlay.on('click.rim', function(e) {
      if (e.target === this) closeModal();
    });
    $(document).on('keydown.rim', function(e) {
      if (e.key === 'Escape') closeModal();
    });
    // 閉じ忘れた場合の Blob URL 解放保険
    setTimeout(function() { URL.revokeObjectURL(imageUrl); }, 60000);

    $overlay.css('display', 'flex').addClass('starting');
    $panel.addClass('starting');
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        $overlay.removeClass('starting');
        $panel.removeClass('starting');
      });
    });
  }

  function showToast(msg) {
    const $t = $('<div>', { class: 'js-ranking-toast ranking-toast' }).text(msg);
    $('body').append($t);
    setTimeout(function() { $t.addClass('is-visible'); }, 10);
    setTimeout(function() { $t.fadeOut(300, function() { $t.remove(); }); }, 4000);
  }
})();
